import moment from 'moment';
import { z } from 'zod';

import { messages } from './BillsFilter.messages';

export const schema = z
    .object({
        dateFrom: z.optional(z.date().nullish()),
        dateTo: z.optional(z.date().nullish()),
        dueDateFrom: z.optional(z.date().nullish()),
        dueDateTo: z.optional(z.date().nullish()),
    })
    .passthrough()
    .refine((value) => !(value.dateFrom && value.dateTo && moment(value.dateFrom).isAfter(value.dateTo)), {
        message: messages.dateFromCantBeAfterDateTo,
        path: ['dateFrom'],
    })
    .refine((value) => !(value.dueDateFrom && value.dueDateTo && moment(value.dueDateFrom).isAfter(value.dueDateTo)), {
        message: messages.dateFromCantBeAfterDateTo,
        path: ['dueDateFrom'],
    });
